import * as React from 'react'
import { ComponentClass, FunctionComponent, ReactElement } from 'react'
import { IButtonProps, IDialogProps } from '@fluentui/react'
import { useBoolean } from '@fluentui/react-hooks'
import Tooltip, { TooltipProps } from '../Tooltip'

export type Props<D extends Omit<IDialogProps, 'hidden' | 'onDismiss'>> = {
    button: FunctionComponent<IButtonProps> | ComponentClass<IButtonProps>
    buttonProps: Omit<IButtonProps, 'onClick'>
    dialog: FunctionComponent<IDialogProps> | ComponentClass<IDialogProps>
    dialogProps?: D
    tooltipProps?: TooltipProps['hostProps']
    display?: TooltipProps['display']
}

// noinspection JSUnusedGlobalSymbols
export default function DialogButton<D extends IDialogProps>(props: Props<D>): ReactElement {
    const [hidden, { setFalse: openDialog, setTrue: closeDialog }] = useBoolean(true)
    return (
        <Tooltip hostProps={props.tooltipProps} display={props.display}>
            <props.button {...props.buttonProps} onClick={openDialog} />
            <props.dialog hidden={hidden} onDismiss={closeDialog} {...props.dialogProps} />
        </Tooltip>
    )
}
